import { useState, useEffect } from 'react';
import { fetchLaunchConfig } from '../services/launchConfigService';

export const useLaunchConfig = () => {
  const [isLaunched, setIsLaunched] = useState(false);
  const [isEmailEnabled, setIsEmailEnabled] = useState(false);
  const [isLinkEnabled, setIsLinkEnabled] = useState(false);
  const [isMarketplaceImportEnabled, setIsMarketplaceImportEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLaunchConfig()
      .then(config => {
        setIsLaunched(config?.isLaunched ?? true);
        setIsEmailEnabled(config?.email || false);
        setIsLinkEnabled(config?.link || false);
        setIsMarketplaceImportEnabled(config?.marketplaceImport || false);
      })
      .catch((err) => {
        console.error('Failed to get launch config', err);
        setIsLaunched(true);
        setIsEmailEnabled(false);
        setIsLinkEnabled(false);
        setIsMarketplaceImportEnabled(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { isLaunched, isEmailEnabled, isLinkEnabled, isMarketplaceImportEnabled, loading };
};
